import $ from 'jquery'; 

function heroStatic(){
   //console.log('heroStatics');
   $('document').ready(function(){
      resizeRealign();
   });
   $(window).resize(function(){
      resizeRealign();
   });
   function resizeRealign(){
      if($(window).width() <= 768){
         console.log('window less');
         $( '.StaticHero' ).css('margin-block-end','0');
      } else {
         console.log('window more');
         let titleHeight = $( '.StaticHero' ).find('h1.leaf').innerHeight();
         let titleWidth = $( '.StaticHero' ).find('h1.leaf').innerWidth();
         $( '.StaticHero' ).find('h1.leaf').css({
            'bottom' : '-' + (titleHeight/2) + 'px',
            'left' : 'calc(50% - ' + (titleWidth/2) + 'px)'
         })
         $( '.StaticHero' ).css('margin-block-end',(titleHeight/2)+'px');
      }
   }
   return (null)
}
export default heroStatic